import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { SettingsProvider } from "./context/SettingsContext";
import Layout from "./components/Layout";
import { Loader } from "./components/kit";
import Login from "./pages/Login";
import Welcome from "./pages/Welcome";
import Dashboard from "./pages/Dashboard";
import MemoCreate from "./pages/MemoCreate";
import MemoView from "./pages/MemoView";
import Memos from "./pages/Memos";
import MemoSample from "./pages/MemoSample";
import Products from "./pages/Products";
import ProductNew from "./pages/ProductNew";
import Stock from "./pages/Stock";
import Customers from "./pages/Customers";
import AllCustomers from "./pages/AllCustomers";
import CustomerDetail from "./pages/CustomerDetail";
import Collection from "./pages/Collection";
import Companies from "./pages/Companies";
import PurchaseCreate from "./pages/PurchaseCreate";
import Purchases from "./pages/Purchases";
import Daily from "./pages/Daily";
import Reports from "./pages/Reports";
import DayCloseReport from "./pages/DayCloseReport";
import Activity from "./pages/Activity";
import Archive from "./pages/Archive";
import Expenses from "./pages/Expenses";
import Settings from "./pages/Settings";
import ProfitReport from "./pages/ProfitReport";
import { applyPrintStyle, loadPrintSize } from "./lib/printSize";

function Protected() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  if (!user) return <Navigate to="/welcome" replace />;
  return <Layout />;
}

function LoginGate() {
  const { user } = useAuth();
  if (user === null) return <Loader />;
  return user ? <Navigate to="/" replace /> : <Login />;
}

export default function App() {
  React.useEffect(() => { applyPrintStyle(loadPrintSize()); }, []);
  return (
    <AuthProvider>
      <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginGate />} />
          <Route path="/welcome" element={<Welcome />} />
          <Route path="/memo-sample" element={<MemoSample />} />
          <Route element={<Protected />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/memo/new" element={<MemoCreate />} />
            <Route path="/barcode-sale" element={<MemoCreate barcodeMode />} />
            <Route path="/memos" element={<Memos />} />
            <Route path="/memos/:id" element={<MemoView />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/new" element={<ProductNew />} />
            <Route path="/stock" element={<Stock />} />
            <Route path="/customers" element={<Customers />} />
            <Route path="/all-customers" element={<AllCustomers />} />
            <Route path="/customers/:id" element={<CustomerDetail />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/purchase/new" element={<PurchaseCreate />} />
            <Route path="/purchases" element={<Purchases />} />
            <Route path="/daily" element={<Daily />} />
            <Route path="/reports" element={<Reports />} />
            <Route path="/reports/:id" element={<DayCloseReport />} />
            <Route path="/activity" element={<Activity />} />
            <Route path="/archive" element={<Archive />} />
            <Route path="/expenses" element={<Expenses />} />
            <Route path="/profit" element={<ProfitReport />} />
            <Route path="/settings" element={<Settings />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors closeButton />
      </SettingsProvider>
    </AuthProvider>
  );
}
